var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecord({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.875 0L11.8906 2.14844L9.75 3.125L11.8906 4.10938L12.875 6.25L13.8516 4.10938L16 3.125L13.8516 2.14844L12.875 0ZM4.22754 10.9383C4.71365 11.4244 5.30393 11.6675 5.99837 11.6675C6.69282 11.6675 7.28309 11.4244 7.76921 10.9383C8.25532 10.4522 8.49837 9.86193 8.49837 9.16748V4.16748C8.49837 3.47304 8.25532 2.88276 7.76921 2.39665C7.28309 1.91054 6.69282 1.66748 5.99837 1.66748C5.30393 1.66748 4.71365 1.91054 4.22754 2.39665C3.74143 2.88276 3.49837 3.47304 3.49837 4.16748V9.16748C3.49837 9.86193 3.74143 10.4522 4.22754 10.9383ZM5.16504 14.9383V17.5008H6.83171V14.9383C8.27615 14.7439 9.47059 14.098 10.415 13.0008C11.3595 11.9036 11.8317 10.6258 11.8317 9.16748H10.165C10.165 10.3203 9.75879 11.3029 8.94629 12.1154C8.13379 12.9279 7.15115 13.3341 5.99837 13.3341C4.84559 13.3341 3.86296 12.9279 3.05046 12.1154C2.23796 11.3029 1.83171 10.3203 1.83171 9.16748H0.165039C0.165039 10.6258 0.637261 11.9036 1.58171 13.0008C2.52615 14.098 3.72059 14.7439 5.16504 14.9383Z",
    fill: "#FF3E4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecord);
export default __webpack_public_path__ + "static/media/record.c92545e2fc335aea9e7d13472be39857.svg";
export { ForwardRef as ReactComponent };